/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var kendo_file_saver_1 = require("@progress/kendo-file-saver");
var kendo_angular_excel_export_1 = require("@progress/kendo-angular-excel-export");
var excel_service_1 = require("./excel.service");
var excel_export_event_1 = require("./excel-export-event");
var kendo_angular_l10n_1 = require("@progress/kendo-angular-l10n");
var kendo_data_query_1 = require("@progress/kendo-data-query");
var column_common_1 = require("../columns/column-common");
/* tslint:disable object-literal-sort-keys */
var fetchComponentData = function (component) {
    return {
        data: component.view.map(function (item) { return item; }),
        group: component.group
    };
};
var ɵ0 = fetchComponentData;
exports.ɵ0 = ɵ0;
var toExcelColumn = function (column) {
    return {
        title: column.title,
        field: column.field,
        locked: Boolean(column.locked),
        width: column.width,
        level: column.level,
        hidden: !column.isVisible,
        groupHeaderTemplate: column.groupHeaderTemplate,
        groupHeaderColumnTemplate: column.groupHeaderColumnTemplate,
        groupFooterTemplate: column.groupFooterTemplate,
        footerTemplate: column.footerTemplate
    };
};
var ɵ1 = toExcelColumn;
exports.ɵ1 = ɵ1;
var toExcelColumns = function (columns) {
    var result = [];
    column_common_1.sortColumns(columns)
        .forEach(function (column) {
        if (column.isSpanColumn) {
            result.push.apply(result, toExcelColumns(column.childrenArray));
        }
        else {
            var excelColumn = toExcelColumn(column);
            if (column.isColumnGroup) {
                excelColumn.children = [excelColumn].concat(toExcelColumns(column.childrenArray));
            }
            result.push(excelColumn);
        }
    });
    return result;
};
var ɵ2 = toExcelColumns;
exports.ɵ2 = ɵ2;
var componentColumns = function (component) {
    var columns = toExcelColumns(component.columns.toArray());
    return kendo_data_query_1.orderBy(columns, [{ field: 'locked', dir: 'desc' }]);
};
var ɵ3 = componentColumns;
exports.ɵ3 = ɵ3;
/**
 * Configures the settings for the export of Grid in Excel ([see example]({% slug excelexport_grid %})).
 */
var ExcelComponent = /** @class */ (function () {
    function ExcelComponent(excelService, localization, zone) {
        this.localization = localization;
        this.zone = zone;
        /**
         * Specifies the file name of the exported Excel file.
         * @default "Export.xlsx"
         */
        this.fileName = 'Export.xlsx';
        /**
         * @hidden
         */
        this.columns = new core_1.QueryList();
        this.saveSubscription = excelService.saveToExcel.subscribe(this.save.bind(this));
    }
    ExcelComponent.prototype.ngOnDestroy = function () {
        this.saveSubscription.unsubscribe();
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
    };
    ExcelComponent.prototype.save = function (component) {
        var _this = this;
        var data = (this.fetchData || fetchComponentData)(component);
        var exportData = function (result) {
            delete _this.dataSubscription;
            _this.exportData(component, result);
        };
        if (data instanceof Promise) {
            data.then(exportData);
        }
        else if (data instanceof rxjs_1.Observable) {
            this.dataSubscription = data.pipe(operators_1.take(1)).subscribe(exportData);
        }
        else {
            exportData(data);
        }
    };
    ExcelComponent.prototype.exportData = function (component, result) {
        var _this = this;
        var options = kendo_angular_excel_export_1.workbookOptions({
            columns: this.columns.length ? this.columns : componentColumns(component),
            data: result.data,
            group: result.group,
            filterable: this.filterable,
            creator: this.creator,
            date: this.date,
            paddingCellOptions: this.paddingCellOptions,
            headerPaddingCellOptions: this.headerPaddingCellOptions,
            rtl: this.localization.rtl,
            collapsible: this.collapsible
        });
        var args = new excel_export_event_1.ExcelExportEvent(options);
        component.excelExport.emit(args);
        if (!args.isDefaultPrevented()) {
            this.zone.runOutsideAngular(function () { return _this.saveFile(options); });
        }
    };
    ExcelComponent.prototype.saveFile = function (options) {
        var _this = this;
        kendo_angular_excel_export_1.toDataURL(options).then(function (dataURL) {
            kendo_file_saver_1.saveAs(dataURL, _this.fileName, {
                forceProxy: _this.forceProxy,
                proxyURL: _this.proxyURL
            });
        });
    };
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", String)
    ], ExcelComponent.prototype, "fileName", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Boolean)
    ], ExcelComponent.prototype, "filterable", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", String)
    ], ExcelComponent.prototype, "creator", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Date)
    ], ExcelComponent.prototype, "date", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Boolean)
    ], ExcelComponent.prototype, "forceProxy", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", String)
    ], ExcelComponent.prototype, "proxyURL", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Function)
    ], ExcelComponent.prototype, "fetchData", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], ExcelComponent.prototype, "paddingCellOptions", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], ExcelComponent.prototype, "headerPaddingCellOptions", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Boolean)
    ], ExcelComponent.prototype, "collapsible", void 0);
    tslib_1.__decorate([
        core_1.ContentChildren(kendo_angular_excel_export_1.ColumnBase, { descendants: true }),
        tslib_1.__metadata("design:type", core_1.QueryList)
    ], ExcelComponent.prototype, "columns", void 0);
    ExcelComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'kendo-grid-excel',
            template: ""
        }),
        tslib_1.__metadata("design:paramtypes", [excel_service_1.ExcelService,
            kendo_angular_l10n_1.LocalizationService,
            core_1.NgZone])
    ], ExcelComponent);
    return ExcelComponent;
}());
exports.ExcelComponent = ExcelComponent;
